import { doRequestNewP } from '../../utils/request';
import { PARQ_API } from '../apiUrl';

const parqApiForPrice = async (lat: any, lng: any) => {
  return doRequestNewP(`${PARQ_API}/?lng=${lng}&lat=${lat}`, 'get');
};

export { parqApiForPrice };
